import "core-js/modules/web.timers";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import pdfPreview from '@/utils/pdfPreview';

var MyPreview = function (_super) {
  __extends(MyPreview, _super);

  function MyPreview() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = true;
    _this.isAgreed = false;
    return _this;
  }

  MyPreview.prototype.onVisibleChange = function (value) {
    var _this = this;

    if (value) {
      var timer_1 = setTimeout(function () {
        _this.$nextTick(function () {
          var pdfRef = _this.$refs.pdfRef;

          if (pdfRef) {
            pdfPreview.preview(pdfRef, _this.url);
          }
        });

        clearTimeout(timer_1);
      });
    }
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], MyPreview.prototype, "url", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], MyPreview.prototype, "onVisibleChange", null);

  MyPreview = __decorate([Component], MyPreview);
  return MyPreview;
}(Vue);

export default MyPreview;